<template>
    <div class="weather">
        <template v-for="(weather,index) in weathers">
            <weather-item :weather="weather" :key="index" ></weather-item>
        </template>
    </div>
</template>
<script>
import WeatherItem from "@/components/Weather/WeatherItem"
import {getWeatherApi} from "@/api/api"
export default {
    'name': 'Weather',
    data(){
        return {
            weathers: []
        }
    },
    components: {WeatherItem},
    created(){
        getWeatherApi().done((rs)=>{
            // console.log(rs);
            var weathers = rs.list.filter((weather, index)=>{
                return index % 8 == 2;
            });
            this.weathers = weathers;
        });

    }
}
</script>
<style>
.weather{
    display: flex;
    justify-content: space-around;
    min-height: 130px;
}
</style>






// WEBPACK FOOTER //
// src/components/Weather.vue